var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"search-container--filters"},[_c('LadSearchCustom',{key:`filters-search`,attrs:{"name":`filters-search`},on:{"on-loading":_vm.handleLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }